(function () {
  'use strict';
  var MODEL_KEY = 'tovynx:model';
  var SAVED_KEY = 'tovynx:saved';
  var SEEN_KEY = 'tovynx:seen';
  function read(key) { try { var value=JSON.parse(localStorage.getItem(key)); return Array.isArray(value)?value:[]; } catch (e) { return []; } }
  function write(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }
  function esc(value) { var d=document.createElement('div'); d.textContent=value || ''; return d.innerHTML; }
  function productFrom(el) {
    var card=el.closest('[data-retention-product]');
    if (card) return {id:String(card.dataset.productId),url:card.dataset.productUrl,title:card.dataset.productTitle,price:card.dataset.productPrice,image:card.dataset.productImage};
    var root=el.closest('article,li,.product-item'); if (!root) return null;
    var link=root.querySelector('a[href*="/products/"]'), img=root.querySelector('img'), title=root.querySelector('h3,a[href*="/products/"]');
    return link ? {id:String(el.dataset.productId || link.href),url:link.getAttribute('href'),title:(title&&title.textContent.trim())||'Saved case',price:'',image:(img&&(img.currentSrc||img.src))||''} : null;
  }
  function addUnique(key,item,limit){if(!item||!item.url)return;var list=read(key).filter(function(x){return x.id!==item.id&&x.url!==item.url;});list.unshift(item);write(key,list.slice(0,limit));}
  document.addEventListener('click', function (event) {
    var target=event.target instanceof Element?event.target:null; if(!target)return;
    var model=target.closest('[data-tovynx-model]'); if(model){try{localStorage.setItem(MODEL_KEY,model.dataset.tovynxModel);}catch(e){}}
    var save=target.closest('[data-tovynx-save],.wishlist-productcard'); if(save){event.preventDefault();event.stopPropagation();var item=productFrom(save);if(!item)return;var list=read(SAVED_KEY), exists=list.some(function(x){return x.id===item.id||x.url===item.url;});list=exists?list.filter(function(x){return x.id!==item.id&&x.url!==item.url;}):[item].concat(list).slice(0,20);write(SAVED_KEY,list);save.setAttribute('aria-pressed',String(!exists));save.classList.toggle('is-saved',!exists);save.innerHTML=!exists?'♥':'♡';render();}
    if(target.closest('[data-tovynx-clear]')){write(SAVED_KEY,[]);write(SEEN_KEY,[]);render();}
  });
  function captureProduct(){if(!/\/products\//.test(location.pathname))return;var title=document.querySelector('meta[property="og:title"]'),image=document.querySelector('meta[property="og:image"]'),price=document.querySelector('meta[property="og:price:amount"]');addUnique(SEEN_KEY,{id:location.pathname,url:location.pathname,title:title?title.content:document.title,price:price?price.content:'',image:image?image.content:''},8);}
  function render(){
    var selected='';try{selected=localStorage.getItem(MODEL_KEY)||'';}catch(e){}
    document.querySelectorAll('[data-tovynx-model-welcome]').forEach(function(el){if(selected){el.hidden=false;el.innerHTML='Welcome back — continue shopping for <strong>'+esc(selected)+'</strong>.';}else{el.hidden=true;}});
    var all=read(SAVED_KEY).concat(read(SEEN_KEY)).filter(function(x,i,a){return x&&x.url&&a.findIndex(function(y){return y&&((y.id&&y.id===x.id)||y.url===x.url);})===i;}).slice(0,8);
    document.querySelectorAll('[data-tovynx-saved-seen]').forEach(function(section){var grid=section.querySelector('[data-tovynx-saved-grid]');section.hidden=!all.length;if(!grid)return;grid.innerHTML=all.map(function(p){return '<article class="tovynx-retention-card" data-retention-product data-product-id="'+esc(p.id)+'" data-product-url="'+esc(p.url)+'" data-product-title="'+esc(p.title)+'" data-product-price="'+esc(p.price)+'" data-product-image="'+esc(p.image)+'"><div class="tovynx-retention-card__media"><a href="'+esc(p.url)+'">'+(p.image?'<img src="'+esc(p.image)+'" alt="'+esc(p.title)+'" loading="lazy">':'')+'</a><button type="button" class="tovynx-save" data-tovynx-save aria-label="Save '+esc(p.title)+'">♡</button></div><h3><a href="'+esc(p.url)+'">'+esc(p.title)+'</a></h3>'+(p.price?'<p>'+esc(p.price)+'</p>':'')+'</article>';}).join('');});
    var saved=read(SAVED_KEY);
    document.querySelectorAll('.wishlist-productcard,[data-tovynx-save]').forEach(function(btn){
      var item=productFrom(btn);
      var isSaved=Boolean(item&&saved.some(function(x){return x&&((x.id&&x.id===item.id)||x.url===item.url);}));
      btn.classList.remove('hidden');
      btn.type='button';
      btn.classList.toggle('is-saved',isSaved);
      btn.setAttribute('aria-pressed',String(isSaved));
      btn.setAttribute('aria-label',isSaved?'Remove from saved cases':'Save for later');
      btn.innerHTML=isSaved?'♥':'♡';
    });
  }
  captureProduct(); if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',render);else render();
})();

/* TOVYNX Favorites hub — header count + /pages/favorites */
(function () {
  'use strict';

  var SAVED_KEY = 'tovynx:saved';
  var hydrating = false;

  function readSaved() {
    try { var value=JSON.parse(localStorage.getItem(SAVED_KEY)); return Array.isArray(value)?value:[]; }
    catch (e) { return []; }
  }

  function writeSaved(value) {
    try { localStorage.setItem(SAVED_KEY, JSON.stringify(value)); }
    catch (e) {}
  }

  function injectHeaderStyles() {
    if (document.getElementById('tovynx-favorites-header-styles')) return;
    var style = document.createElement('style');
    style.id = 'tovynx-favorites-header-styles';
    style.textContent =
      '#root .tvx-header-v3 .tovynx-header__actions{gap:8px!important}' +
      '#root .tvx-header-v3 .tvx-header-favorites{display:inline-flex!important;min-height:40px!important;align-items:center!important;gap:7px!important;padding:0 13px!important;border:1px solid #cfd5df!important;background:#fff!important;color:#11131a!important;font-size:10px!important;font-weight:900!important;letter-spacing:.06em!important;text-transform:uppercase!important;transition:border-color .18s,background .18s,color .18s!important}' +
      '#root .tvx-header-v3 .tvx-header-favorites:hover,#root .tvx-header-v3 .tvx-header-favorites:focus-visible{border-color:#2057d4!important;background:#f4f7fd!important;color:#1744af!important;outline:0!important}' +
      '#root .tvx-header-v3 .tvx-header-favorites__heart{font-size:16px!important;line-height:1!important}' +
      '#root .tvx-header-v3 .tvx-header-favorites__count{display:inline-flex!important;min-width:19px!important;height:19px!important;align-items:center!important;justify-content:center!important;padding:0 5px!important;border-radius:999px!important;background:#11131a!important;color:#fff!important;font-size:9px!important;letter-spacing:0!important}' +
      '#root .tvx-header-v3 .tovynx-mobile-actions{display:none!important}' +
      '@media(max-width:899px){#root .tvx-header-v3 .tovynx-mobile-actions{display:flex!important;grid-column:3!important;grid-row:1!important;align-items:center!important;justify-self:end!important;gap:5px!important;white-space:nowrap!important}#root .tvx-header-v3 .tovynx-mobile-actions .tovynx-mobile-cart{display:inline-flex!important;grid-column:auto!important;grid-row:auto!important;justify-self:auto!important}#root .tvx-header-v3 .tvx-mobile-favorites{position:relative!important;display:inline-flex!important;width:27px!important;height:38px!important;align-items:center!important;justify-content:center!important;color:#11131a!important;font-size:18px!important;line-height:1!important}#root .tvx-header-v3 .tvx-mobile-favorites__count{position:absolute!important;top:3px!important;right:-2px!important;display:flex!important;min-width:14px!important;height:14px!important;align-items:center!important;justify-content:center!important;padding:0 3px!important;border-radius:999px!important;background:#2057d4!important;color:#fff!important;font-size:8px!important;font-weight:900!important;line-height:1!important}#root .tvx-header-v3 .tvx-mobile-favorites__count[hidden]{display:none!important}}' +
      '@media(max-width:390px){#root .tvx-header-v3 .tovynx-mobile-actions{gap:3px!important}#root .tvx-header-v3 .tvx-mobile-favorites{width:23px!important;font-size:17px!important}}';
    document.head.appendChild(style);
  }

  function makeFavoritesLink(mobile) {
    var link = document.createElement('a');
    link.className = mobile ? 'tvx-mobile-favorites' : 'tvx-header-favorites';
    link.href = '/pages/favorites';
    link.setAttribute('data-tovynx-favorites-link', '');
    link.setAttribute('aria-label', 'Favorites with 0 saved cases');

    var heart = document.createElement('span');
    heart.className = mobile ? 'tvx-mobile-favorites__heart' : 'tvx-header-favorites__heart';
    heart.setAttribute('data-tovynx-favorites-heart', '');
    heart.setAttribute('aria-hidden', 'true');
    heart.textContent = '♡';
    link.appendChild(heart);

    if (!mobile) {
      var text = document.createElement('span');
      text.textContent = 'Favorites';
      link.appendChild(text);
    }

    var count = document.createElement('span');
    count.className = mobile ? 'tvx-mobile-favorites__count' : 'tvx-header-favorites__count';
    count.setAttribute('data-tovynx-favorites-count', '');
    count.textContent = '0';
    if (mobile) count.hidden = true;
    link.appendChild(count);

    return link;
  }

  function ensureHeader() {
    var root = document.querySelector('[data-tovynx-header]');
    if (!root) return;
    injectHeaderStyles();

    var desktop = root.querySelector('.tovynx-header__actions');
    if (desktop && !desktop.querySelector('.tvx-header-favorites')) {
      desktop.insertBefore(makeFavoritesLink(false), desktop.firstChild);
      desktop.setAttribute('aria-label', 'Store actions');
    }

    var mobileCart = root.querySelector('.tovynx-mobile-cart');
    if (mobileCart && !root.querySelector('.tovynx-mobile-actions')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'tovynx-mobile-actions';
      mobileCart.parentNode.insertBefore(wrapper, mobileCart);
      wrapper.appendChild(makeFavoritesLink(true));
      wrapper.appendChild(mobileCart);
    }
  }

  function updateHeader(saved) {
    var n = saved.length;
    document.querySelectorAll('[data-tovynx-favorites-count]').forEach(function (el) {
      el.textContent = String(n);
      if (el.classList.contains('tvx-mobile-favorites__count')) el.hidden = n === 0;
    });
    document.querySelectorAll('[data-tovynx-favorites-heart]').forEach(function (el) {
      el.textContent = n ? '♥' : '♡';
    });
    document.querySelectorAll('[data-tovynx-favorites-link]').forEach(function (el) {
      el.setAttribute('aria-label', n === 1 ? 'Favorites with 1 saved case' : 'Favorites with ' + n + ' saved cases');
    });
  }

  function makeCard(item) {
    var card = document.createElement('article');
    card.className = 'tvx-favorite-card';
    card.setAttribute('data-retention-product', '');
    card.dataset.productId = String(item.id || item.url || '');
    card.dataset.productUrl = item.url || '';
    card.dataset.productTitle = item.title || 'Saved case';
    card.dataset.productPrice = item.price || '';
    card.dataset.productImage = item.image || '';

    var media = document.createElement('div');
    media.className = 'tvx-favorite-card__media';

    var mediaLink = document.createElement('a');
    mediaLink.href = item.url || '/collections/all';

    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image;
      img.alt = item.title || 'Saved TOVYNX case';
      img.loading = 'lazy';
      mediaLink.appendChild(img);
    } else {
      var placeholder = document.createElement('span');
      placeholder.className = 'tvx-favorite-card__placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.textContent = 'TOVYNX';
      mediaLink.appendChild(placeholder);
    }

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'tvx-favorite-card__remove is-saved';
    remove.setAttribute('data-tovynx-save', '');
    remove.setAttribute('aria-pressed', 'true');
    remove.setAttribute('aria-label', 'Remove ' + (item.title || 'case') + ' from favorites');
    remove.textContent = '♥';

    media.appendChild(mediaLink);
    media.appendChild(remove);

    var body = document.createElement('div');
    body.className = 'tvx-favorite-card__body';

    var title = document.createElement('h2');
    var titleLink = document.createElement('a');
    titleLink.href = item.url || '/collections/all';
    titleLink.textContent = item.title || 'Saved case';
    title.appendChild(titleLink);
    body.appendChild(title);

    if (item.price) {
      var price = document.createElement('p');
      price.className = 'tvx-favorite-card__price';
      price.textContent = item.price;
      body.appendChild(price);
    }

    var view = document.createElement('a');
    view.className = 'tvx-favorite-card__view';
    view.href = item.url || '/collections/all';
    view.textContent = 'View case ';
    var arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    view.appendChild(arrow);
    body.appendChild(view);

    card.appendChild(media);
    card.appendChild(body);
    return card;
  }

  function renderPage(saved) {
    document.querySelectorAll('[data-tovynx-favorites-page]').forEach(function (page) {
      var grid = page.querySelector('[data-tovynx-favorites-page-grid]');
      var empty = page.querySelector('[data-tovynx-favorites-empty]');
      var count = page.querySelector('[data-tovynx-favorites-page-count]');
      var clear = page.querySelector('[data-tovynx-clear-saved]');

      if (count) count.textContent = saved.length === 1 ? '1 saved case' : saved.length + ' saved cases';
      if (empty) empty.hidden = saved.length > 0;
      if (clear) clear.hidden = saved.length === 0;

      if (grid) {
        grid.hidden = saved.length === 0;
        grid.replaceChildren();
        saved.forEach(function (item) { if(item&&item.url) grid.appendChild(makeCard(item)); });
      }
    });
  }

  function productJsonUrl(url) {
    try {
      var path = new URL(url, location.origin).pathname.replace(/\/$/, '');
      return /\/products\//.test(path) ? path + '.js' : '';
    } catch (e) { return ''; }
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      var amount=Number(cents);
      if(!Number.isFinite(amount)) return '';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {
        style: 'currency',
        currency: currency
      }).format(amount / 100);
    } catch (e) { return ''; }
  }

  function hydrate(saved) {
    if (hydrating || !document.querySelector('[data-tovynx-favorites-page]')) return;
    var needs = saved.filter(function (item) { return item && item.url && (!item.price || !item.image); });
    if (!needs.length) return;

    hydrating = true;
    Promise.all(needs.map(function (item) {
      var url = productJsonUrl(item.url);
      if (!url) return Promise.resolve(null);
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('unavailable'); return r.json(); })
        .then(function (p) {
          return {
            id: String(item.id || item.url),
            url: item.url,
            title: p.title || item.title || 'Saved case',
            price: p.price != null ? money(p.price) : (item.price || ''),
            image: p.featured_image || (p.images && p.images[0]) || item.image || ''
          };
        })
        .catch(function () { return null; });
    })).then(function (updates) {
      var byUrl = {};
      updates.filter(Boolean).forEach(function (item) { byUrl[item.url] = item; });
      var current = readSaved();
      var changed = false;
      current = current.map(function (item) {
        if (item&&byUrl[item.url]) { changed = true; return byUrl[item.url]; }
        return item;
      }).filter(function(item){return item&&item.url;});
      hydrating = false;
      if (changed) {
        writeSaved(current);
        refresh();
      }
    }).catch(function () { hydrating = false; });
  }

  function refresh() {
    ensureHeader();
    var saved = readSaved().filter(function(item){return item&&item.url;});
    updateHeader(saved);
    renderPage(saved);
    hydrate(saved);
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('[data-tovynx-clear-saved]')) {
      event.preventDefault();
      writeSaved([]);
      refresh();
      return;
    }

    if (target.closest('[data-tovynx-save],.wishlist-productcard')) {
      window.setTimeout(refresh, 0);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();

  window.addEventListener('storage', function (event) {
    if (event.key === SAVED_KEY) refresh();
  });
})();
